var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useMemo, useReducer } from 'react';
import { apiGetListClientRfpShareDocumentOneMessage } from '@/actions/ClientRfpShareDocumentActions';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { reducer, initialState, updateRfpCliFileMessageAction, } from '@/pages/rfp/client/RfpClientOneFileOne/RfpClientOneFileOneMessageReducer';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { isNotEmptyNumber } from '@/utils/checkValue/number';
/**
 * データの取得, ローディング制御
 */
export const useRfpClientOneFileOneFetchMessage = (args) => {
    const { dispatch, id, profile, unmountRef, viewRequestId } = args;
    // メッセージ情報
    const [messageState, messageDispatch] = useReducer(reducer, initialState);
    // 閲覧申請IDに対応するメッセージ情報
    const messageData = messageState[viewRequestId];
    /**
     * ユーザーのデータ propsに渡す用
     */
    const user = useMemo(() => ({
        clientId: `${profile.id}`,
        firstName: profile.information.firstName,
        isShowDetailPage: false,
        lastName: profile.information.lastName,
        professionalId: '', // 企業アカウントのため false 固定
    }), [profile]);
    /**
     * コンポーネント表示ように整形したメッセージ一覧
     */
    const chatItems = useMemo(() => {
        if (!messageData) {
            // TODO: コンポーネントの修正範囲が大きくなるのでやむなく...
            return undefined;
        }
        return messageData.messages.map((message) => {
            const clientId = message.client_id;
            const isClientMessage = isNotEmptyNumber(clientId);
            return {
                message: {
                    files: message.files.map((file) => ({
                        // リンククリック時にはこのIDを使ってアクセスする
                        id: file.rfp_share_document_message_file_id,
                        name: file.name,
                    })),
                    isBox: !message.is_same_organization && !message.is_self,
                    message: message.message || '',
                    messageId: message.id,
                    time: message.published_at,
                    unread: message.is_unread,
                },
                user: {
                    clientId: isClientMessage ? clientId.toString() : '',
                    firstName: message.first_name,
                    imageSrc: message.image_src,
                    isRetired: message.is_retired,
                    isShowDetailPage: !!message.has_professional_detail_page,
                    lastName: message.last_name,
                    professionalId: isNotEmptyNumber(message.professional_id)
                        ? message.professional_id.toString()
                        : '',
                    professionalType: message.professional_type,
                },
            };
        });
    }, [messageData]);
    /**
     * 個別メッセージ一覧の取得を行う
     */
    const baseFetchMessage = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        // 情報を取得・整形し、stateに反映
        const { payload } = yield wrapDispatch(dispatch, apiGetListClientRfpShareDocumentOneMessage({ path: { id, view_request_id: viewRequestId } }, {}));
        messageDispatch(updateRfpCliFileMessageAction(viewRequestId, payload));
    }), [dispatch, id, viewRequestId, messageDispatch]);
    const { callbackPromiseEvent: fetchMessage, doing: loadingOfMessage } = usePromiseDoingCallback({
        promiseEvent: baseFetchMessage,
        unmountRef,
    });
    return {
        chatItems,
        fetchMessage,
        hasInitialMessageData: messageData !== undefined,
        loadingOfMessage,
        messageData,
        messageDispatch,
        user,
    };
};
